var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header-image',{attrs:{"src":"hero-main5.jpg"}},[_c('h1',[_vm._v(_vm._s(this.pageResource))])]),_c('section',[(!_vm.loading)?_c('b-container',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})]):_c('b-container',[_c('div',{staticClass:"text-center"},[_vm._v(" Cargando... ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }